import { getTransformedScenariosForDex } from 'utils/transformations/tosca-dex';
import {
  HYPERTEST_TASK_LOG_ACTIONS_REQUEST,
  HYPERTEST_TASK_LOG_ACTIONS_SILENT_REQUEST,
  HYPERTEST_TASK_LOG_ACTIONS_RESPONSE,
  HYPERTEST_TASK_LOG_RESET,
  HYPERTEST_SET_ACTIVE_STAGE_LOG,
  HYPERTEST_SET_CURRENT_RUNNING_LOGTYPE,
} from '../constants/hypertestTaskLog';
import { convertTimeTaken } from 'utils/new-theme-common';

const initialState = {
  hypertestTaskLog: {
    data: null,
    loading: true,
    error: false,
  },
  dataCheckDone: false,
  activeStageLog: 0,
  currentRunningLogType: '',
};

function hypertestTaskLogReducer(state = initialState, actions) {
  const { type, payload, error } = actions;
  switch (type) {
    case HYPERTEST_TASK_LOG_ACTIONS_REQUEST:
      return {
        ...state,
        dataCheckDone: false,
        hypertestTaskLog: {
          ...state.hypertestTaskLog,
          loading: true,
        },
      };
    case 'HYPERTEST_SCENARIO_LIST_RESPONSE':
      let formatedData = [];
      if (
        actions?.query?.from !== 0 &&
        state?.hypertestTaskLog?.data?.data?.length
      ) {
        formatedData = [...state?.hypertestTaskLog?.data?.scenarioList];
      }

      payload?.scenarios?.forEach((scenario) => {
        scenario?.stages?.forEach((stage) => {
          const dataFormat = {
            org_id: null,
            id: stage?.stage_id,
            task: stage?.task_id,
            type: 'scenario',
            status: stage?.status,
            remark: stage?.status || '',
            name: scenario?.name,
            iteration: stage?.retry_number,
            order: stage?.stage_order,
            duration: convertTimeTaken(stage?.duration || 0),
            link: 'command.1.0.log',
          };
          formatedData.push(dataFormat);
        });
        formatedData.push({
          type: 'spacer',
          height: 12,
        });
      });
      return {
        ...state,
        hypertestTaskLog: {
          ...state.hypertestTaskLog,
          data: {
            scenarioList: formatedData,
            data: formatedData,
          },
          search_text: actions?.query?.search || '',
          loading: false,
          error: error === undefined ? false : error,
          total: payload?.total || 0,
        },
      };
    case HYPERTEST_TASK_LOG_ACTIONS_RESPONSE:
      let dexData = getTransformedScenariosForDex(payload);

      return {
        ...state,
        dataCheckDone: true,
        hypertestTaskLog: {
          ...state.hypertestTaskLog,
          data:
            dexData?.length ||
            payload?.data?.hasOwnProperty('execution_list_results')
              ? { data: dexData }
              : payload,
          loading: false,
          error: error === undefined ? false : error,
        },
      };
    case HYPERTEST_TASK_LOG_ACTIONS_SILENT_REQUEST:
      return {
        ...state,
        hypertestTaskLog: {
          ...state.hypertestTaskLog,
          loading: false,
        },
      };
    case HYPERTEST_SET_ACTIVE_STAGE_LOG:
      return {
        ...state,
        activeStageLog: payload,
      };
    case HYPERTEST_SET_CURRENT_RUNNING_LOGTYPE:
      return {
        ...state,
        currentRunningLogType: payload,
      };
    case HYPERTEST_TASK_LOG_RESET:
      return initialState;
    default:
      return state;
  }
}

export default hypertestTaskLogReducer;
